const urlArvoresMonitora = "/arvoresmonitora";
const urlParametroExercicio = "/parametroexercicios";

export function carregarArvoreMonitora() {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlArvoresMonitora}/carregar`).then((res) => {
      resolve(res.data);
    });
  });
}

export function carregarArvoreResumidaMonitora() {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${urlArvoresMonitora}/carregararvoreresumidav2`).then((res) => {
      resolve(res.data);
    });
  });
}

function removeDuplicatas(arr) {
  const arrs = {};
  return arr.filter((item) => {
      if(item.idenPrograma)
        {if (arrs.hasOwnProperty(item.idenPrograma)) {
            return false;
        } else {
          arrs[item.idenPrograma] = true;
            return true;
        }
      }else
      if(item.key){
        if (arrs.hasOwnProperty(item.key)) {
          return false;
        } else {
          arrs[item.key] = true;
            return true;
        }
      }else
      if(item.codigoFiplanItem){
        if (arrs.hasOwnProperty(item.codigoFiplanItem)) {
          return false;
        } else {
          arrs[item.codigoFiplanItem] = true;
            return true;
        }
      }
  });
}

export function carregarArvoreMonitoraComFiltro(filtro, pRetorno, eager = false, page = 0, size = 20) {
  let defaultArvore = { content: { key: null, statusItem: null, tipoItemPta: null } };
  let retorno = {
    arvorePtaMonitoras: pRetorno.arvorePtaMonitoras != null ? pRetorno.arvorePtaMonitoras : defaultArvore,
    listaExercicios: pRetorno.listaExercicios != null ? pRetorno.listaExercicios : null,
    parametroExercicio: pRetorno.parametroExercicio != null ? pRetorno.parametroExercicio : null,
    orgaoFiplans: pRetorno.orgaoFiplans != null ? pRetorno.orgaoFiplans : null,
    unidadeOrcamentarias: pRetorno.unidadeOrcamentarias != null ? pRetorno.unidadeOrcamentarias : null,
    programas: pRetorno.programas != null ? pRetorno.programas : null,
    acao: pRetorno.acao != null ? pRetorno.acao : null,
    produto: pRetorno.produto != null ? pRetorno.produto : null,
    subAcao: pRetorno.subAcao != null ? pRetorno.subAcao : null,
    ciclo: pRetorno.ciclo != null ? pRetorno.ciclo : null,
    listaUnidadeExecucao: pRetorno != null ? pRetorno.listaUnidadeExecucao : null,
    listaSubUnidadeExecucao: pRetorno != null ? pRetorno.listaSubUnidadeExecucao : null,
    listaStatusExecucao: pRetorno != null ? pRetorno.listaStatusExecucao : null,
    intervaloExec: pRetorno != null ? pRetorno.intervaloExec : null,
    solucaoRestricoes: pRetorno != null ? pRetorno.solucaoRestricoes : null,
  };

  if (filtro.idenPrograma != null) {
    return new Promise((resolve, reject) => {
      if (eager === false) {
        window.$http
          .get(
            `${urlArvoresMonitora}/visoes/${filtro.idenOrgao}/${filtro.idenUo}/${filtro.idenPrograma}?page=${page}&size=${size}`
          )
          .then((res) => {
            retorno.arvorePtaMonitoras = res.data;
            resolve(retorno);
          });
      }
      if (eager === true) {
        window.$http
          .get(`${urlArvoresMonitora}/visoesResumida/${filtro.idenOrgao}/${filtro.idenUo}/${filtro.idenPrograma}`)
          .then((res) => {
            retorno.arvorePtaMonitoras = res.data;
            resolve(retorno);
          });
      }
    });
  } else if (filtro.idenUo != null) {
    return new Promise((resolve, reject) => {
      Promise.all(filtro.idenUo.map(f => {
        return window.$http.get(`${urlArvoresMonitora}/programas/${f.orgaoFiplan.idenOrgao}/${f.idenUo}`);
      })).then((res) => {
        let programas = res.map((r) => r.data).reduce((acc, curr) => acc.concat(curr), [])
        let programasFiltro = removeDuplicatas(programas);
        retorno.programas = programasFiltro;
        resolve(retorno);
      }).catch(reject);
    });
  } else if (filtro.idenOrgao != null) {
    return new Promise((resolve, reject) => {
      Promise.all(filtro.idenOrgao.map(f => {
        return window.$http.get(`${urlArvoresMonitora}/uos/${f.idenOrgao}`);
      })).then(responses => {
        // responses é um array de respostas HTTP
        retorno.unidadeOrcamentarias = responses.map(res => res.data).flat();
        resolve(retorno);
      }).catch(reject);
    });
  } else if (filtro.idenExercicio != null) {
    return new Promise((resolve, reject) => {
      window.$http.get(`${urlArvoresMonitora}/orgaos/${filtro.idenExercicio}`).then((res) => {
        retorno.orgaoFiplans = res.data;
        retorno.arvorePtaMonitoras = defaultArvore;
        retorno.unidadeOrcamentarias = null;
        retorno.programas = null;
        retorno.produto = null;
        window.$http.get(`${urlParametroExercicio}/exercicio/${filtro.idenExercicio}`).then((res) => {
          retorno.parametroExercicio = res.data;
          resolve(retorno);
        });
      });
    });
  } else if (filtro.listaPrograma != null) {
    return new Promise((resolve, reject) => {
      window.$http.post(`${urlArvoresMonitora}/acao/permissao`).then((res, res2) => {
        retorno.acao = res.data;
        retorno.produto = [];
        retorno.subAcao = res2.data;
        resolve(retorno);
      });
    });
  }
}
export function buscarAcao(JsonBody) {
  let JsonBodyFilter = JsonBody;
  let uos = JsonBody.listaUnidOrcamentaria[0].map(f => f.idenUo);
  let progs = JsonBody.listaPrograma[0].map(f => f.idenPrograma);

  return new Promise(async (resolve, reject) => {
    Promise.all(JsonBody.listaUnidOrcamentaria.map((f) => {
      JsonBodyFilter.listaUnidOrcamentaria = uos;
      JsonBodyFilter.listaPrograma = progs;
    return window.$http.post("/arvoresmonitora/acao/permissao", JSON.stringify(JsonBodyFilter));
    })).then((res) => {
      let acoes = res.map((r) => r.data).reduce((acc, curr) => acc.concat(curr), [])
      let acoesFiltro = removeDuplicatas(acoes);
      resolve(acoesFiltro);
    });
  });
}
export function buscarExercicio() {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/arvoresmonitora/carregar").then((res) => {
      resolve(res);
    });
  });
}

export function buscaProduto(idenPtaMonitora) {
  return new Promise(async (resolve, reject) => {
    Promise.all(idenPtaMonitora.map((f) => {
    return window.$http.get("/arvoresmonitora/produto/permissao/" + f);
    })).then((res) => {
        let produtos = res.map((r) => r.data).reduce((acc, curr) => acc.concat(curr), [])
        let produtosFiltro = removeDuplicatas(produtos);
        resolve(produtosFiltro);
    });
  });
}

export function buscarSubAcao(idenPtaMonitora) {
  return new Promise(async (resolve, reject) => {
    Promise.all(idenPtaMonitora.map((f) => {
    return window.$http.get("/arvoresmonitora/subacao/permissao/" + f);
    })).then((res) => {
        let subAcoes = res.map((r) => r.data).reduce((acc, curr) => acc.concat(curr), [])
        let subAcoesFiltro = removeDuplicatas(subAcoes);
        resolve(subAcoesFiltro);
    });
  });
}
export function buscaCiclo(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/ciclos/exercicio/" + idenExercicio).then((res) => {
      resolve(res);
    });
  });
}

export function buscaUnidadeExecucao(idenUnidadeExecucao) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/unidadesexecucao/buscarSubUnidadesExecucao/" + idenUnidadeExecucao).then((res) => {
      resolve(res);
    });
  });
}

export function buscaSubUnidadeExecucao(idenUnidadeExecucao) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/unidadesexecucao/buscarSubUnidadesExecucao/" + idenUnidadeExecucao).then((res) => {
      resolve(res);
    });
  });
}

export function buscaStatusExecucao() {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/status/listarRelatorio/").then((res) => {
      resolve(res);
    });
  });
}
export function gerarRelatorioRestricao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelrestitensmonitoraveis", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function buscarOrgaos(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/arvoresmonitora/orgaos/" + idenExercicio).then((res) => {
      resolve(res);
    });
  });
}

export function listarExercicios() {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/arvoresmonitora/exercicios").then((res) => {
      resolve(res);
    });
  });
}

export function buscarOrgaosRag(idenExercicio) {
  return new Promise(async (resolve, reject) => {
    window.$http.get("/arvoresrag/orgaos/" + idenExercicio).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioPermissoes(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelpermissoes", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioFinanceiroSintetico(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelfinanceirosinteticoacao", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}
export function gerarRelatorioFinanceiroAnalitco(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelfinanceiroanalitico", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}
export function gerarRelatorioBaseGeral(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelbasegeral", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioExecucaoFisicaAnalitica(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelexecfisicaanalitica", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioExecucaoFisicaSintetico(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelexecfisicasintetico", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioStatusExecucao(JsonBody) {
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelstatusexecucao", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}

export function getArvoreIdenPtaFiplan(itemPai) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/arvoresmonitora/buscarPeloIdenItemPai/${itemPai}`).then((res) => {
      resolve(res);
    });
  });
}

export function gerarRelatorioMonitoraConsolidado(JsonBody){
  return new Promise(async (resolve, reject) => {
    window.$http.post("/relatorios/monrelconsolidado", JSON.stringify(JsonBody)).then((res) => {
      resolve(res);
    });
  });
}